import React, { useRef, useEffect, useState } from "react";
import { getHomeData, toggleSeguirComercio, obtenerDetalleComercio, registrarTap, guardarUbicacionHistorial, registrarTrafico } from "../api";
import RecomiendaBox from "../components/Recomienda";
import ReferidosModal from "../components/ReferidosModal";
import BottomNavigation from "../components/BottomNavigation";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import ClimaWidget from "../components/ClimaWidget";
import PromoRewardsCard from "../components/PromoRewardsCard";
import { useNavigate, useNavigationType } from "react-router-dom";
import CategoriasScroll from "../components/CategoriasScroll";
import { v4 as uuidv4 } from "uuid";
import { calcularDistancia } from "../utils/geo";
import { useBottomSheet } from "../context/BottomSheetContext";
import { toast } from "react-hot-toast";
import SugerenciasCarousel from "../components/SugerenciasCarousel";
import HomeReels from "../components/HomeReels";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { esIOSWebView } from "../utils/detectarIOS";
import { useDetalleComercioStore } from '../stores/detalleComercioStore';
import isoImage from "../assets/images/iso.png";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Home = () => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userId = userData?.id || null;
  const [animacionCargada, setAnimacionCargada] = useState(false);
  const [categoriasScroll, setCategoriasScroll] = useState(null);
  const [loadingHome, setLoadingHome] = useState(true);
  const showSplash = useDynamicSplash(loadingHome, { delayMs: 120, minVisibleMs: 120 });
  const [homePromo, setHomePromo] = useState(null);
  const [squareBanner, setSquareBanner] = useState(null);
  const [squareBannerCargado, setSquareBannerCargado] = useState(false);
  const [historias, setHistorias] = useState([]);
  const { openBottomSheet } = useBottomSheet();
  const cintilloRef = useRef(null);
  const [eventosHome, setEventosHome] = useState([]);
  const [eventosTotal, setEventosTotal] = useState(0);
  const [data, setData] = useState({ eventosHome: [] });
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
  const tipoNavegacion = useNavigationType();
  const [showReferidos, setShowReferidos] = useState(false);
  const [comerciosConDistancia, setComerciosConDistancia] = useState([]);
  const [comercios, setComercios] = useState([]);
  const [clima, setClima] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [randomCategorias, setRandomCategorias] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [destinos, setDestinos] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [cintillo, setCintillo] = useState(null);
  const [showGame, setShowGame] = useState(null);
  const [headerScrolled, setHeaderScrolled] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const estaLogueado = user && user.id;
  const { guardarDetalle } = useDetalleComercioStore.getState();

  useEffect(() => {
    const onScroll = () => {
      const y =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      setHeaderScrolled(y > 60);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("scroll", onScroll, { capture: true });
    };
  }, []);

  useEffect(() => {
    if (categorias && categorias.length > 0) {
      const shuffled = [...categorias].sort(() => Math.random() - 0.5).slice(0, 10);
      setRandomCategorias(shuffled);
    } else {
      setRandomCategorias([]);
    }
  }, [categorias]);

  useEffect(() => {
    if (!comercios || comercios.length === 0) return;

    const objetivos = comercios.slice(0, 3);
    const timerId = window.setTimeout(() => {
      objetivos.forEach(async (comercio) => {
        try {
          const detalle = await obtenerDetalleComercio(comercio.id_sucursal, user?.id || 0);
          if (detalle && detalle.success) {
            guardarDetalle(comercio.id, detalle);
          }
        } catch (error) {}
      });
    }, 1200);

    return () => window.clearTimeout(timerId);
  }, [comercios]);

  const fetchData = async () => {
    try {
      const data = await getHomeData(user?.id || 0);

      const latUser = localStorage.getItem("userLat");
      const lngUser = localStorage.getItem("userLng");

      const comerciosFinal = (data.comercios || []).map((comercio) => {
        let distancia = "Acceso a la ubicación requerido.";

        if (latUser && lngUser && comercio.lat && comercio.lng) {
          distancia = calcularDistancia(
            parseFloat(latUser),
            parseFloat(lngUser),
            parseFloat(comercio.lat),
            parseFloat(comercio.lng)
          );
        }

        return {
          ...comercio,
          seguido: Number(comercio.seguido), // forzado a número
          distancia,
        };
      });

      setComercios(comerciosFinal);
      setComerciosConDistancia(comerciosFinal);
      setClima(data.clima || null);
      setCategoriasScroll(data.categoriasScroll || null);
      setDestinos(data.destinos || []);
      setCategorias(data.categorias || []);
      setHistorias(data.historias || []);
      setCintillo(data.cintillo || null);
      setSquareBanner(data.squareBanner || null);
      setHomePromo(
        data.homePromo || (data.sliders?.[0] ? {
          title: data.sliders[0].titulo,
          subtitle: data.sliders[0].descripcion,
          image: data.sliders[0].imagen,
          id_sucursal: data.sliders[0].id_sucursal,
          link: data.sliders[0].id_sucursal ? `/comercio/app/${data.sliders[0].id_sucursal}` : null,
          bgColor: "#14c85f",
          buttonText: "Descubre ahora",
          imageAlt: data.sliders[0].titulo,
        } : null)
      );
      setShowGame(data.showGame[0].description);
      setEventosHome(data.eventosHome || []);
      setEventosTotal(data.eventosTotal || 0);
    } catch (error) {
      // Silencioso en producción: la UI ya maneja el estado sin mostrar logs.
    } finally {
      setIsReady(true);
      setAnimacionCargada(true);
      setLoadingHome(false);
    }
  };

  useEffect(() => {
    document.body.style.overflow = showSplash ? "hidden" : "auto";
  }, [showSplash]);

  const handleNotificaciones = () => {
    if (!user || !user.id) {
      toast.dismiss();
      toast.error("Debes iniciar sesión para ver tus notificaciones.");
      return;
    }
    navigate("/notificaciones");
  };

  const handleHomePromoClick = () => {
    if (!homePromo?.link) return;

    const rawLink = homePromo.link.trim();
    const isInternalRoute = rawLink.startsWith("/");
    const finalUrl = /^https?:\/\//i.test(rawLink) || isInternalRoute ? rawLink : `https://${rawLink}`;

    registrarTap(homePromo.id_sucursal || 0, "home_promo", userId || null, null, finalUrl).finally(() => {
      if (isInternalRoute) {
        navigate(finalUrl);
        return;
      }

      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", finalUrl);
        return;
      }

      window.open(finalUrl, "_blank", "noopener,noreferrer");
    });
  };

  useEffect(() => {
    let anonId = localStorage.getItem("anon_id");
  
    if (!anonId) {
      anonId = uuidv4();
      localStorage.setItem("anon_id", anonId);
    }
  
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("registrarDispositivo", {
        anon_id: anonId,
      });
    }
  }, []);  

  const handleToggleSeguir = async (id_comercio) => {
    if (!user || !user.id) {
      toast.dismiss();
      toast.error("Debes iniciar sesión para seguir comercios.");
      return;
    }
  
    const result = await toggleSeguirComercio(user.id, id_comercio);
  
    if (result.success) {
      setComerciosConDistancia((prev) =>
        prev.map((c) =>
          c.id === id_comercio
            ? { ...c, seguido: !!result.followed }
            : c
        )
      );
      toast.dismiss();
      toast.success(result.message);
    } else {
      toast.dismiss();
      toast.error(result.message || "No se pudo seguir el comercio.");
    }
  };  

  const handleVerMapa = async () => {
    const lat = localStorage.getItem("userLat");
    const lng = localStorage.getItem("userLng");
  
    if (lat && lng) {
      await guardarUbicacionHistorial(lat, lng, user?.id || 0);
      navigate("/mapa");
      return;
    }
  
    const esIOS = esIOSWebView();
  
    if (esIOS) {
      const tienePermiso = await window.flutter_inappwebview?.callHandler("verificarUbicacion");
  
      if (!tienePermiso) {
        toast.dismiss();
        toast.error("Se necesita acceso a tu ubicación para ver el mapa.");
        return;
      }
  
      const lat = await window.flutter_inappwebview.callHandler("obtenerLat");
      const lng = await window.flutter_inappwebview.callHandler("obtenerLng");
  
      if (lat && lng) {
        localStorage.setItem("userLat", lat);
        localStorage.setItem("userLng", lng);
        await guardarUbicacionHistorial(lat, lng, user?.id || 0);
        navigate("/mapa");
        return;
      }
  
      toast.dismiss();
      toast.error("No se pudo obtener la ubicación.");
      return;
    }
  
    // Android / Web
    const tienePermiso = await window.flutter_inappwebview?.callHandler("verificarUbicacion");
  
    if (!tienePermiso) {
      toast.dismiss();
      toast.error("Se necesita acceso a tu ubicación para ver el mapa.");
      return;
    }
  
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          localStorage.setItem("userLat", latitude);
          localStorage.setItem("userLng", longitude);
          await guardarUbicacionHistorial(latitude, longitude, user?.id || 0);
          navigate("/mapa");
        },
        (error) => {
          toast.dismiss();
          toast.error("No se pudo obtener la ubicación.");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
        }
      );
    } else {
      toast.dismiss();
      toast.error("Tu dispositivo no soporta geolocalización.");
    }
  };  

  useEffect(() => {
    if (user !== undefined) {
      const latUser = localStorage.getItem("userLat");
      const lngUser = localStorage.getItem("userLng");
      registrarTrafico("home", latUser, lngUser);
    }
  }, [user]);
  
  useEffect(() => {
    const cache = sessionStorage.getItem("homeLoaded");
    const isBack = tipoNavegacion === "POP";
    setLoadingHome(true);

    fetchData().then(() => {
      if (!isBack && !cache) {
        sessionStorage.setItem("homeLoaded", "1");
      }
    });
  }, []);  

  useEffect(() => {
    if (!cintilloRef.current || !cintillo || !cintillo.imagen) return;
  
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
  
        if (entry.isIntersecting) {
          registrarTap(null, "cintillo", userId || null, null, cintillo.enlace || null, 1);
        }
      },
      { threshold: 0.5 }
    );
  
    observer.observe(cintilloRef.current);
  
    return () => observer.disconnect();
  }, [cintillo]);  

  useEffect(() => {
    setSquareBannerCargado(false);
  }, [squareBanner?.image]);

  const handleSquareBannerClick = () => {
    if (!squareBanner?.link) return;

    const rawLink = squareBanner.link.trim();
    const isInternalRoute = rawLink.startsWith("/");
    const finalUrl = /^https?:\/\//i.test(rawLink) || isInternalRoute ? rawLink : `https://${rawLink}`;

    if (isInternalRoute) {
      navigate(finalUrl);
      return;
    }

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("abrirEnlaceExterno", finalUrl);
      return;
    }

    window.open(finalUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
       {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" loading="lazy" style={{ width: 300 }} alt="Cargando..."/>
        </div>
      )}
      {!showSplash && animacionCargada && (
      <motion.div
        initial={!animacionCargada ? { y: "100%", opacity: 0 } : false}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: "100%", opacity: 0 }}
        transition={{ duration: !animacionCargada ? 0.7 : 0, ease: "easeInOut" }}
      >
        <div className="app-container">
        <header className={`app-header-home ${headerScrolled ? "is-hidden" : ""}`}>
          <div className="app-header-home__top">
            <img src="/assets/images/logo_w.png" loading="lazy" alt="Ubikalo!" className="app-header-home__logo" />
            <button type="button" className="app-header-home__icon-btn" onClick={handleNotificaciones} aria-label="Notificaciones">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18.134 11C18.715 16.375 21 18 21 18H3s3-2.133 3-9.6c0-1.697.632-3.325 1.757-4.525S10.41 2 12 2q.507 0 1 .09M19 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6m-5.27 13a2 2 0 0 1-3.46 0" />
              </svg>
            </button>
          </div>
          <div id="open-search" className="app-header-home__search" onClick={openBottomSheet} role="button">
            <span className="app-header-home__search-placeholder">Busca comercios, servicios, productos o destinos...</span>
            <span className="app-header-home__search-btn" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m17 17l4 4M3 11a8 8 0 1 0 16 0a8 8 0 0 0-16 0"/>
              </svg>
            </span>
          </div>
          {randomCategorias.length > 0 && (
            <div className="app-header-home__categories">
              {randomCategorias.map((cat) => (
                <div
                  key={cat.id}
                  className="app-header-home__category"
                  onClick={() => navigate(`/comercios/${cat.id}`, { state: { from: "featured" } })}
                >
                  <div className="app-header-home__category-icon">
                    <img
                      src={cat.icono ? cat.icono : "/assets/images/default.png"}
                      alt={cat.nombre}
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/images/default.png";
                      }}
                    />
                  </div>
                  <span className="app-header-home__category-name">{cat.nombre}</span>
                </div>
              ))}
              <div
                className="app-header-home__category"
                onClick={() => navigate("/categorias")}
              >
                <div className="app-header-home__category-icon">
                  <span style={{ fontSize: 13, fontWeight: 800 }}>+</span>
                </div>
                <span className="app-header-home__category-name">Ver más</span>
              </div>
            </div>
          )}
        </header>
        <header className={`app-header-sticky ${headerScrolled ? "is-visible" : ""}`}>
          <img src="/assets/images/logo_w.png" loading="lazy" alt="Ubikalo!" className="app-header-sticky__logo" />
          <button type="button" className="app-header-sticky__icon-btn" onClick={openBottomSheet} aria-label="Buscar">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m17 17l4 4M3 11a8 8 0 1 0 16 0a8 8 0 0 0-16 0"/>
            </svg>
          </button>
        </header>
        <main className="home-content-shell">
          {categoriasScroll && (
            <CategoriasScroll data={categoriasScroll}/>
          )}

          {isReady && homePromo?.image && (
            <section
              className="home-promo-card"
              style={{ backgroundColor: "#000" }}
            >
              <div className="home-promo-card__copy">
                <p className="home-promo-card__eyebrow">• {homePromo.kicker || "Promoción"}</p>
                <h2 className="home-promo-card__title">{homePromo.title || homePromo.titulo}</h2>
                <p className="home-promo-card__subtitle">{homePromo.subtitle || homePromo.descripcion}</p>
                <button type="button" className="home-promo-card__cta" onClick={handleHomePromoClick}>
                  {homePromo.buttonText || "Descubre ahora"}
                </button>
              </div>
              <div className="home-promo-card__art-wrap" aria-hidden="true">
                <button
                  type="button"
                  className="home-promo-card__art"
                  onClick={handleHomePromoClick}
                  aria-label={homePromo.title || "Abrir promoción"}
                >
                  <img
                    src={homePromo.image}
                    loading="lazy"
                    alt={homePromo.imageAlt || homePromo.title || "Promoción"}
                  />
                </button>
              </div>
            </section>
          )}
      
      <HomeReels />

        {isReady && squareBanner?.image && (
          <section className="home-square-banner">
            {!squareBannerCargado && <div className="home-square-banner__skeleton" aria-hidden="true" />}
            <button
              type="button"
            className="home-square-banner__button"
            onClick={handleSquareBannerClick}
            aria-label="Abrir banner promocional"
              >
                <img
                  src={squareBanner.image}
                  loading="lazy"
                  alt=""
                  aria-hidden="true"
                  onLoad={() => setSquareBannerCargado(true)}
                  onError={() => setSquareBannerCargado(true)}
                  style={{ opacity: squareBannerCargado ? 1 : 0 }}
                />
                <span className="home-square-banner__ad-label">ANUNCIOS</span>
              </button>
          </section>
        )}

      <SugerenciasCarousel
        comercios={comerciosConDistancia}
        estaLogueado={estaLogueado}
        handleToggleSeguir={handleToggleSeguir}
      />
      <div className="btn-center-container">
        <button className="btn-ver-mapa" onClick={handleVerMapa}>
          <img src={isoImage} width={14} alt="ISO" />
          Ubika en el Mapa
        </button>
      </div>

      {parseInt(localStorage.getItem("id_perfil")) === 2 && (
        <a href="#" onClick={(e) => {
          e.preventDefault();
          navigate("/emergencias");
        }} style={{textAlign:"center",}}>Abrir botón</a>
      )}
      <section className="home-quick-links">
        <button style={{background:"#5a9bd5"}} type="button" className="home-quick-link home-quick-link--explore" onClick={() => navigate("/destinos")}>
          <div className="home-quick-link__art">
            <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 24 24">
	<path d="M0 0h24v24H0z" fill="none" />
	<path fill="#fff" d="m8.914 15.596l4.261-1.373q.385-.13.651-.397t.397-.651L15.6 8.909q.071-.232-.106-.406q-.178-.174-.407-.1l-4.262 1.374q-.384.13-.651.397q-.266.267-.397.651L8.4 15.091q-.071.232.106.406q.178.174.407.1m3.082-2.482q-.466 0-.788-.326q-.323-.327-.323-.794q0-.466.327-.788q.327-.323.793-.323q.467 0 .79.327q.322.327.322.793q0 .467-.327.79q-.327.321-.793.321M12.003 21q-1.867 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.344 0 5.672-2.328T20 12t-2.328-5.672T12 4T6.328 6.328T4 12t2.328 5.672T12 20m0-8" />
</svg>

          </div>
          <div className="home-quick-link__copy">
            <h3>Explorar</h3>
            <p>Destinos turísticos, naturaleza y planes para salir.</p>
          </div>
        </button>

        <button style={{background:"#9fd158"}} type="button" className="home-quick-link home-quick-link--fun" onClick={() => navigate("/eventos")}>
          <div className="home-quick-link__art">
            <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 256 256">
	<path d="M0 0h256v256H0z" fill="none" />
	<path fill="#fff" d="M116 68.1V16a4 4 0 0 0-8 0v52.1a84 84 0 1 0 8 0m71.89 79.9h-40c-1-37.34-15.73-60.22-25.35-71.25A76.12 76.12 0 0 1 187.89 148M112 226.68C105 220 85.26 197.61 84.06 156h55.88c-1.2 41.61-20.94 64-27.94 70.68M84.06 148c1.2-41.61 21-64 27.94-70.68c7 6.64 26.74 29.07 27.94 70.68Zm17.36-71.25c-9.62 11-24.35 33.91-25.35 71.25h-40a76.12 76.12 0 0 1 65.35-71.25M36.11 156h40c1 37.34 15.73 60.22 25.35 71.25A76.12 76.12 0 0 1 36.11 156m86.47 71.25c9.62-11 24.35-33.91 25.35-71.25h40a76.12 76.12 0 0 1-65.35 71.25M252 88a4 4 0 0 1-4 4h-12v12a4 4 0 0 1-8 0V92h-12a4 4 0 0 1 0-8h12V72a4 4 0 0 1 8 0v12h12a4 4 0 0 1 4 4m-40-48a4 4 0 0 1-4 4h-20v20a4 4 0 0 1-8 0V44h-20a4 4 0 0 1 0-8h20V16a4 4 0 0 1 8 0v20h20a4 4 0 0 1 4 4" />
</svg>

          </div>
          <div className="home-quick-link__copy">
            <h3>Diversión</h3>
            <p>Eventos, shows y experiencias para disfrutar hoy.</p>
          </div>
        </button>
      </section>

      {showGame === "1" && (
      <div className="card-juegos">
        <div className="botones-juegos">
          <button className="btn-juego" onClick={() => navigate(`/memoria`)}>Juega memoria</button>
          <button className="btn-juego" onClick={() => navigate(`/juegoruleta`)}>Juega ruleta</button>
        </div>
      </div>
      )}
      <PromoRewardsCard />

      <BottomNavigation />
      {showReferidos && (
        <ReferidosModal user={user} onClose={() => setShowReferidos(false)} />
      )}
        </main>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Home;
